module.exports = "<div class=\"filter-map\" style=\"display:none;\">\n  <div id=\"map2\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter-map/filter-map.component.html
// module id = ./src/app/filter-map/filter-map.component.html
// module chunks = main